export default __webpack_public_path__ + "static/person-game-1-fe35224fcef86ecd464e5e288e22b10a.png";